/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Badge_Limit_HitInputs */



/**
* | output |
* | --- |
* | "Limit hit" |
*
* @param {Status_Badge_Limit_HitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const status_badge_limit_hit = /** @type {((inputs?: Status_Badge_Limit_HitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Badge_Limit_HitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Limit erreicht")
	return /** @type {LocalizedString} */ ("Limit hit")
});